import CryptoJS from 'crypto-js';

const getKey = () => process.env.REACT_APP_ENCRYPT_KEY;

export const encryptPassword = (plain) => {
    try {
        const key = getKey();
        if (!key) {
            console.error('REACT_APP_ENCRYPT_KEY is not set; rebuild the frontend with it.');
            throw new Error('Sign-in is temporarily unavailable. Please try again later or contact support.');
        }
        return CryptoJS.AES.encrypt(plain, key).toString();
    } catch (e) {
        console.error('Error encrypting password:', e);
        throw e;
    }
};
